export const ERROR_HANDLER_INTERCEPTOR_I18N = {
  message: {
    serverError: $localize`:@@errorHandler.message.serverError:サーバからの情報が取得できませんでした。`,
  },
  button: {
    close: $localize`:@@errorHandler.button.close:閉じる`,
  },
} as const;
